"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocalStorage = {
	consentPolicy: {
		functional: true
	},

	setConsentPolicy: function setConsentPolicy(policy) {
		this.consentPolicy = policy;
	},
	clearExpired: function clearExpired() {
		if (!LocalStorage.exists()) {
			return;
		}

		var now = new Date().getTime();

		for (var key in localStorage) {
			try {
				var obj = JSON.parse(localStorage[key]);
				if (obj.expire < now) {
					localStorage.removeItem(key);
				}
			} catch (err) {}
		}
	},
	exists: function exists() {
		try {
			if (typeof localStorage === "undefined") return false;
			if (localStorage === null) return false;
			return true;
		} catch (e) {
			return false;
		}
	},
	put: function put(key, value, expire) {
		if (!LocalStorage.exists()) {
			return;
		}

		if (LocalStorage.consentPolicy && !LocalStorage.consentPolicy.functional) {
			return;
		}

		var stored = {
			obj: value
		};
		if (expire) {
			stored.expire = expire;
		}

		try {
			localStorage.setItem(key, (0, _stringify2.default)(stored));
		} catch (e) {
			//console.log(e);
		}
	},
	get: function get(key) {
		if (!LocalStorage.exists()) {
			return null;
		}

		var storedJson;
		try {
			storedJson = localStorage.getItem(key);
		} catch (e) {
			//console.log(e);
			return null;
		}
		if (!storedJson) {
			return null;
		}

		var stored;
		try {
			stored = JSON.parse(storedJson);
		} catch (e) {
			return null;
		}

		if (stored.expire && new Date().getTime() > stored.expire) {
			localStorage.removeItem(key);
			return null;
		}

		return stored.obj ? stored.obj : null;
	},
	remove: function remove(key) {
		if (!LocalStorage.exists()) {
			return;
		}

		try {
			localStorage.removeItem(key);
		} catch (e) {}
	}
};

exports.default = LocalStorage;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/LocalStorage.js
// module id = 465
// module chunks = 0